/**
 * @generated SignedSource<<46caa94db655a5a7feb29148e44bd010>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data = {
  readonly portals: ReadonlyArray<{
    readonly isFeatured: boolean | null | undefined;
    readonly portalId: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
  } | null | undefined>;
  readonly " $fragmentType": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement";
};
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$key = {
  readonly " $data"?: listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "HelpLayoutPortalCard",
        "kind": "LinkedField",
        "name": "portals",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "portal_HelpCenterPortal"
          },
          {
            "kind": "ScalarField",
            "name": "isFeatured"
          },
          {
            "kind": "ScalarField",
            "name": "portalId"
          }
        ]
      },
      "action": "THROW",
      "path": "portals"
    }
  ],
  "type": "HelpLayoutPortalsListElement"
};

(node as any).hash = "01d5ce6146bcce71aced56cd72428f5d";

export default node;
